module.exports = __webpack_public_path__ + "static/img/community11.5692a97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/community11.png
// module id = 0Wzt
// module chunks = 0